<p-card>
    <p-tabs value="0">
        <p-tablist>
            <p-tab value="0">Upload</p-tab>
            <p-tab value="1" (click)="handleLogTabChange(0)">History</p-tab>
        </p-tablist>
        <p-tabpanels>
            <!-- Upload -->
            <p-tabpanel value="0">
                <p>
                    This page enables internal administrators to upload various integration and
                    mapping files for the client being impersonated. After a successful upload, the
                    file will undergo additional processing. Please allow time for this to complete
                    and then proceed to the History tab for review.
                </p>

                <p-confirmpopup />

                <!-- Upload Containers -->
                <ng-container *ngFor="let upload of uploadOptions">
                    <p-divider styleClass="py-2" type="dashed"></p-divider>

                    <div class="flex flex-row justify-content-between align-items-center pb-2">
                        <span class="font-bold">{{ upload.label }}</span>
                        <p-button
                            label="Download"
                            severity="secondary"
                            size="small"
                            icon="pi pi-download"
                            [loading]="upload.downloading"
                            [disabled]="upload.downloading"
                            (click)="confirmDownloadType($event, upload)"
                        />
                    </div>

                    <p-progressbar
                        mode="indeterminate"
                        [style]="{ height: '6px' }"
                        *ngIf="upload.uploading"
                    ></p-progressbar>

                    <p-fileupload
                        [name]="upload.name"
                        #uploadElement
                        accept=".csv"
                        maxFileSize="5000000"
                        mode="advanced"
                        [chooseLabel]="'Choose ' + upload.label + ' CSV'"
                        [multiple]="false"
                        [disabled]="upload.uploading"
                        [customUpload]="true"
                        (uploadHandler)="onUpload($event, upload, uploadElement)"
                        [showUploadButton]="!upload.uploading"
                        [showCancelButton]="!upload.uploading"
                    ></p-fileupload>
                </ng-container>
            </p-tabpanel>

            <!-- History Log -->
            <p-tabpanel value="1">
                <div class="file-upload-log-area-tabs">
                    <mat-tab-group
                        animationDuration="0ms"
                        [selectedIndex]="logTabIndex"
                        (selectedIndexChange)="handleLogTabChange($event)"
                        dynamicHeight
                    >
                        <mat-tab *ngFor="let tab of fileUploadTypeLogTab">
                            <ng-template mat-tab-label>
                                <div class="file-upload-log-area-tab-title">
                                    {{ tab.title }}
                                </div>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>

                <div class="file-upload-log-data-area">
                    <custom-mat-table
                        [customTableInfo]="customTableInfo"
                        (cellClickedEvent)="cellClickedEvent($event)"
                    ></custom-mat-table>
                </div>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</p-card>
